import { APICore } from './apiCore'

const api = new APICore()

function getServicios (params) {
  const baseUrl = '/servicios'
  return api.get(baseUrl, params)
}

function getServicio (id) {
  const baseUrl = `/servicios/${id}`
  return api.get(baseUrl, {})
}

function addServicio (params) {
  const baseUrl = '/servicios'
  return api.createWithFile(baseUrl, params)
}

function updateServicio (params) {
  const baseUrl = '/servicios'
  return api.updateWithFile(baseUrl, params)
}

function deleteServicio (params) {
  const baseUrl = '/servicios'
  return api.delete(baseUrl, params)
}

export { getServicios, getServicio, addServicio, updateServicio, deleteServicio }
